module.exports = __webpack_public_path__ + "static/media/lizard.64f95cf2.jpg";